(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name crewing.controller:ShowExpiryInfoCtrl
     *
     * @description
     *
     */
    angular
        .module('crewing')
        .controller('ShowExpiryInfoCtrl', ShowExpiryInfoCtrl);

    function ShowExpiryInfoCtrl(modalParams, $uibModalInstance,CrewingHelper) {
        var vm = this;
        vm.model = {
            expiryData: modalParams.expiryInfo.EXPIRY
        };
        
        vm.closeMe = function () {
            $uibModalInstance.close();
        };
    }
}());